module.exports = __webpack_public_path__ + "fonts/Manrope-400-greek3.4f6140c.woff2";